import { Routes, RouterModule } from '@angular/router'

import { LoginComponent } from './login/login.component'
import { InicioComponent } from './inicio/inicio.component'
import { NormasComponent } from './normas/normas.component'
import { ActividadesComponent } from './actividades/actividades.component'
import { ErrorComponent } from './404/error.component'
import { PerfilComponent } from './perfil/perfil.component'
import { InventarioNormasComponent } from './inventarionormas/inventarionormas.component'
import { EvidenciasComponent } from './evidencias/evidencias.component'
import { EvidenciasINComponent } from './evidencias/evidenciasin.component'
import { DragDropComponent } from './dragdrop/dragdrop.component'
import { CuestionarioComponent } from './cuestionario/cuestionario.component';
import { CuestionarioFullComponent } from './cuestionario/cuestionariofull.component';
import { CuestionariosComponent } from './cuestionario/cuestionarios.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuarioComponent } from './usuarios/usuario.component';
import { EmpresasComponent } from './empresas/empresas.component';
import { EmpresaComponent } from './empresas/empresa.component';
import { CentrosDeTrabajoComponent } from './centrosdetrabajo/centrosdetrabajo.component';
import { CentroDeTrabajoComponent } from './centrosdetrabajo/centrodetrabajo.component';
import { EvidenciasVistaComponent } from './evidencias/evidenciasvista.component';
import { LicenciaComponent } from './licencias/licencia.component';
import { LicenciasComponent } from './licencias/licencias.component';
import { InstalacionesComponent } from './instalaciones/instalaciones.component';
import { EquiposComponent } from './equipos/equipos.component';
import { TipoCentrosComponent } from './tipocentros/tipocentros.component';
import { InventarioNormasPenalComponent } from './inventarionormaspenal/inventarionormaspenal.component';
import {TextospredefinidosComponent} from './textospredefinidos/textospredefinidos.component';
import { UsuariorolesComponent } from './usuarioroles/usuarioroles.component';

const APP_ROUTES: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'login/:accion', component: LoginComponent },
  { path: 'inicio', component: InicioComponent },
  { path: 'inicio/:accion', component: InicioComponent },
  { path: 'actividades', component: ActividadesComponent },
  { path: 'capturadenormas', component: NormasComponent },
  { path: 'capturadenormas/:id', component: NormasComponent },
  { path: '', component: InicioComponent},
  { path: 'perfil', component: PerfilComponent },
  { path: 'capturaevidencias', component: InventarioNormasComponent },
  { path: 'capturaevidencias/:bloque', component: InventarioNormasComponent },
  { path: 'capturaevidenciaspenal', component: InventarioNormasPenalComponent },
  { path: 'capturaevidenciaspenal/:bloque', component: InventarioNormasPenalComponent },
  { path: 'inventarionormas', component: EvidenciasINComponent },
  { path: 'inventarioevidencias', component: EvidenciasVistaComponent },
  { path: 'dragdrop', component: DragDropComponent },
  { path: 'cuestionarios', component: CuestionariosComponent },
  { path: 'cuestionarios/:id_modulo', component: CuestionariosComponent },
  { path: 'cuestionario', component: CuestionarioComponent },
  { path: 'cuestionario/:id', component: CuestionarioComponent },
  { path: 'cuestionario/:id/:test', component: CuestionarioComponent },
  { path: 'cuestionariofull/:id', component: CuestionarioFullComponent },
  { path: 'usuarios', component: UsuariosComponent },
  { path: 'usuarios/:id_usuario', component: UsuarioComponent },
  { path: 'empresas', component: EmpresasComponent },
  { path: 'empresas/:id_empresa', component: EmpresaComponent },
  { path: 'centrosdetrabajo', component: CentrosDeTrabajoComponent },
  { path: 'centrosdetrabajo/:id_ct', component: CentroDeTrabajoComponent },
  { path: 'licencias/:id_licencia', component: LicenciaComponent },
  { path: 'licencias', component: LicenciasComponent },
  { path: 'instalaciones', component: InstalacionesComponent },
  { path: 'equipos', component: EquiposComponent },
  { path: 'tipocentros', component: TipoCentrosComponent },
  { path: 'textospredefinidos', component: TextospredefinidosComponent },
  { path: 'usuariosroles', component: UsuariorolesComponent },
  { path: '**', component: ErrorComponent}
]

export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts